export class GetUserDetails {
    constructor(userRepository) {
      this.userRepository = userRepository;
    }
  
    async execute(Email) {
        console.log("get GetUserDetails repository", Email)
      return await this.userRepository.GetUserDetails(Email);
    }
  }